import React from 'react';

export default function InsertBefore(props) {
  return (
    <svg width="21px" height="18px" viewBox="0 0 21 18" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" {...props}>
        {/* Generator: Sketch 53.1 (72631) - https://sketchapp.com */}
        <title>Group 2</title>
      <desc>Created with Sketch.</desc>
      <defs>
        <path d="M0.2854375,2.99859375 L11.56225,2.99859375 L11.56225,0.28546875 C11.56225,0.20815625 11.5905313,0.14125 11.647,0.08475 C11.7035313,0.02821875 11.7704688,0 11.84775,0 C11.9310938,0 11.9994375,0.02675 12.0529688,0.08025 L15.908,3.93515625 C15.9614063,3.98884375 15.98825,4.05709375 15.98825,4.14053125 C15.98825,4.21775 15.9615313,4.28328125 15.908,4.336625 L12.0618438,8.19178125 C11.9904375,8.25121875 11.9190625,8.280875 11.8476562,8.280875 C11.770375,8.280875 11.7034375,8.25265625 11.6469375,8.19628125 C11.5904687,8.139625 11.5621875,8.072875 11.5621875,7.9954375 L11.5621875,5.2824375 L0.2854375,5.2824375 C0.208,5.2824375 0.14128125,5.25434375 0.08459375,5.19775 C0.028125,5.14115625 0,5.07434375 0,4.99690625 L0,3.28390625 C0,3.2065625 0.02821875,3.13975 0.08459375,3.08328125 C0.14128125,3.0268125 0.20803125,2.99859375 0.2854375,2.99859375 Z" id="path-1" />
      </defs>
      <g id="Map-interactions" stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
        <g id="Stop-Move-on-the-Map" transform="translate(-708.000000, -357.000000)">
          <g id="Group-2" transform="translate(708.000000, 358.000000)">
            <g id="color/blue-#0095C7" transform="translate(0.000000, 4.000000)">
              <mask id="mask-2" fill="white">
                <use xlinkHref="#path-1" />
              </mask>
              <use id="Combined-Shape" fill={'currentColor'} fillRule="nonzero" xlinkHref="#path-1" />
            </g>
            <path d="M19.5,0 L19.5,16" id="Line-11" stroke={'currentColor'} strokeWidth={2} strokeLinecap="square" />
          </g>
        </g>
      </g>
    </svg>
  );
}
